module.exports = __webpack_public_path__ + "media/honey-icons/icon-receiver-dual-816219d5.svg";